import React, { Component } from "react";
import styles from "./taskTripSettings.module.scss";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import ModalConfirmWindow from "../../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../../Contents/ModalComponents/DeleteConfirm";
import Scrollbars from "react-custom-scrollbars-2";
import { Radio } from "@mui/material";
import "./customStyle.css";
import ButtonPrimary from "../../../../shared/items/contols/buttonPrimary";
import { states } from "../../../../reducers/queriesStates";
import getDates from "../../../../shared/services/date.service";

class TaskTripUnitsSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenModal: false,
      errorMessage: null,
    };
  }

  componentDidUpdate(preProps) {
    const { monitoringAddUnitToTaskTripDataState, errors } = this.props;

    if (monitoringAddUnitToTaskTripDataState === states.FAILURE && preProps.monitoringAddUnitToTaskTripDataState === states.REQUEST) {
      const error = errors.data.split("\n\r")[0];

      if (error !== undefined) {
        this.setState({ errorMessage: error });
      }
    }
  }

  onSetUnitState(route, controlPoint) {
    const { onSetMonitoringSettingsState, monitoringSettingsState } = this.props;

    monitoringSettingsState.unitState.routeId = route.id;
    monitoringSettingsState.unitState.routeTitle = route.title;
    monitoringSettingsState.unitState.controlPointId = controlPoint.id;
    monitoringSettingsState.unitState.controlPointTitle = controlPoint.title;
    monitoringSettingsState.unitState.controlPointAddress = controlPoint.address;

    onSetMonitoringSettingsState(monitoringSettingsState);
  }

  onSetAddUnit() {
    const { onAddUnitToTaskTrip, monitoringSettingsState } = this.props;

    onAddUnitToTaskTrip(monitoringSettingsState.unitState);
    this.setState({ isOpenModal: false });
  }

  render() {
    const { monitoringTaskTrip, monitoringSettingsState } = this.props;
    const { isOpenModal, errorMessage } = this.state;

    if (monitoringTaskTrip === null || monitoringSettingsState.modificationType !== 0) return null;

    const height = window.innerHeight > 800 ? 600 : 400;

    const isButtonView =
      monitoringSettingsState.unitState !== null &&
      monitoringSettingsState.unitState.id != null &&
      monitoringSettingsState.unitState.unitId != null &&
      monitoringSettingsState.unitState.routeId != null &&
      monitoringSettingsState.unitState.controlPointId != null;

    let count = 0;

    return (
      <div className={styles.taskTripUnitsSettingsContainer}>
        <div className={styles.taskCPTableHeader}>
          <div style={{ width: "115px" }}></div>
          <div style={{ width: "415px" }}>
            <b>Наименование контрольной точки</b>
          </div>
          <div>
            <b>Адрес</b>
          </div>
        </div>
        <div>
          <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
            {monitoringTaskTrip.units.map((unit, indexUnit) => {
              const islastUnit = indexUnit === monitoringTaskTrip.units.length - 1;

              if (!islastUnit) {
                unit.routes.forEach((route) => {
                  count += route.controlPoints.length;
                });
              }

              return (
                <div key={unit.id}>
                  {unit.routes.map((route) => {
                    return (
                      <div key={route.id}>
                        <div style={{ marginBottom: "5px" }}>
                          <div>
                            <b>
                              {unit.title} {unit.registerNumber}
                            </b>
                          </div>
                          <div>Маршрут: {route.title}</div>
                        </div>

                        {islastUnit ? (
                          <div>
                            {route.controlPoints.map((controlPoint) => {
                              const isCheckControlPoint =
                                monitoringSettingsState.unitState !== null &&
                                monitoringSettingsState.unitState.routeId === route.id &&
                                monitoringSettingsState.unitState.controlPointId === controlPoint.id;

                              const timeEndLessCurrent = Date.parse(monitoringTaskTrip.timeEnd) > Date.parse(new Date().toISOString());

                              return (
                                <div key={controlPoint.id} className={styles.taskTripUnitsSettingsCPItem}>
                                  <div>
                                    {controlPoint.status === 0 && timeEndLessCurrent ? (
                                      <Radio
                                        checked={isCheckControlPoint}
                                        size="small"
                                        style={{ padding: "0px!important" }}
                                        onClick={() => {
                                          this.onSetUnitState(route, controlPoint);
                                        }}
                                      />
                                    ) : (
                                      <div style={{ width: "15px" }}></div>
                                    )}
                                  </div>
                                  <div style={{ width: "25px" }}>
                                    <b>{++count}.</b>
                                  </div>
                                  <div style={{ width: "400px" }}>{controlPoint.title}</div>
                                  <div>{controlPoint.address}</div>
                                </div>
                              );
                            })}
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </Scrollbars>

          {isButtonView && !monitoringSettingsState.isModificating && monitoringTaskTrip.taskTripModifications.length === 0 ? (
            <div className={styles.taskTripUnitsButtonContainer}>
              <ButtonPrimary
                handleClick={() => {
                  this.setState({ isOpenModal: true });
                }}
                title="Назначить на рейс"
              />
              {errorMessage !== null ? <div className={styles.errorMessage}>{errorMessage}</div> : null}
            </div>
          ) : null}
        </div>

        {monitoringSettingsState.unitState !== null ? (
          <div>
            <ModalConfirmWindow isOpen={isOpenModal}>
              <DeleteConfirm
                onConfirmHandle={() => {
                  this.onSetAddUnit();
                }}
                onNotConfirmHandle={(e) => {
                  this.setState({ isOpenModal: false });
                }}
                text={[
                  `Назначить на рейс? "${monitoringTaskTrip.title}"`,
                  `Транспортное средство: ${monitoringSettingsState.unitState.unitTitle}`,
                  `Регистрационный номер: ${monitoringSettingsState.unitState.unitRegisterNumber}`,
                  `С контрольной точки: "${monitoringSettingsState.unitState.controlPointTitle}"`,
                  `По адресу: "${monitoringSettingsState.unitState.controlPointAddress}"`,
                  `Маршрута: "${monitoringSettingsState.unitState.routeTitle}"`,
                ]}
              />
            </ModalConfirmWindow>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withMonitoringTaskTrips(React.memo(TaskTripUnitsSettings));
